export default __webpack_public_path__ + "static/media/Kothian Battle Greaves.cd359f2b.jpg";